const parseAdjust = (eventDate) => {
  const date = new Date(eventDate);
  return date;
};

export { parseAdjust };
